import styled from 'styled-components';
import { spacer16, spacer24 } from '@spotify-internal/encore-foundation';
export default styled.footer.withConfig({
  displayName: "Footer",
  componentId: "sc-16q321o-0"
})(["position:relative;padding:", " ", ";> *{align-items:center;display:flex;justify-content:space-between;}"], spacer16, spacer24);